import { createFeatureSelector, createSelector } from '@ngrx/store';

import { RequestStatus } from '../../enums/request-status.enum';
import { LinkTemplatesState } from './link-templates.reducer';

export const selectLinkTemplatesState = createFeatureSelector<LinkTemplatesState>('linkTemplates');

export const selectLinkTemplates = createSelector(
  selectLinkTemplatesState,
  (state) => state.templates
);

export const selectLinkTemplatesMeta = createSelector(
  selectLinkTemplatesState,
  (state) => state.meta
);

export const selectLinkTemplatesLoading = createSelector(
  selectLinkTemplatesState,
  (state) => state.listStatus === RequestStatus.Loading
);

export const selectCurrentLinkTemplate = createSelector(
  selectLinkTemplatesState,
  (state) => state.currentTemplate
);

export const selectLinkTemplateLoading = createSelector(
  selectLinkTemplatesState,
  (state) => state.detailStatus === RequestStatus.Loading
);

export const selectLinkTemplateSaving = createSelector(
  selectLinkTemplatesState,
  (state) => state.saveStatus === RequestStatus.Loading
);

export const selectLinkTemplateDeleting = createSelector(
  selectLinkTemplatesState,
  (state) => state.deleteStatus === RequestStatus.Loading
);

export const selectLinkTemplateDefaultUpdating = createSelector(
  selectLinkTemplatesState,
  (state) => state.defaultStatus === RequestStatus.Loading
);

export const selectLinkTemplatesExporting = createSelector(
  selectLinkTemplatesState,
  (state) => state.exportStatus === RequestStatus.Loading
);

export const selectLinkTemplatesExportMessage = createSelector(
  selectLinkTemplatesState,
  (state) => state.exportMessage
);

export const selectLinkTemplatesError = createSelector(
  selectLinkTemplatesState,
  (state) => state.error
);

export const selectLinkTemplatesLastQuery = createSelector(
  selectLinkTemplatesState,
  (state) => state.lastQuery
);
